import type { SecondStepContactForm } from '../config/second-step';
import { superForm } from 'sveltekit-superforms/client';

export const getSecondStepData = (data: SecondStepContactForm, onSubmit: () => void) => {
  const { form, errors, enhance } = superForm(data, {
    taintedMessage: false,
    resetForm: true,
    id: 'contact-us-second-step',
    onResult: ({ result }) => {
      if (result.type === 'success') {
        onSubmit();
      }
    },
  });

  return {
    form,
    errors,
    enhance,
  };
};
